<template>
  <div class="store-checkin-container">
    <!-- 新增：统计卡片区域 -->
    <div class="statistics-card-container">
      <el-row :gutter="20">
        <!-- 卡片1：总招商数 -->
        <el-col :span="6">
          <el-card class="stat-card total-card" shadow="hover">
            <div class="stat-content">
              <div class="stat-icon">
                <i class="el-icon-store-building"></i>
              </div>
              <div class="stat-info">
                <div class="stat-label">总招商登记数</div>
                <div class="stat-value">{{ statistics.totalCount }}</div>
              </div>
            </div>
          </el-card>
        </el-col>
        
        <!-- 卡片2：已签约数 -->
        <el-col :span="6">
          <el-card class="stat-card signed-card" shadow="hover">
            <div class="stat-content">
              <div class="stat-icon">
                <i class="el-icon-check"></i>
              </div>
              <div class="stat-info">
                <div class="stat-label">已签约商户数</div>
                <div class="stat-value">{{ statistics.signedCount }}</div>
                <div class="stat-rate">签约率：{{ statistics.signRate }}%</div>
              </div>
            </div>
          </el-card>
        </el-col>
        
        <!-- 卡片3：重点行业分布 -->
        <el-col :span="6">
          <el-card class="stat-card industry-card" shadow="hover">
            <div class="stat-content">
              <div class="stat-icon">
                <i class="el-icon-s-data"></i>
              </div>
              <div class="stat-info">
                <div class="stat-label">主要行业</div>
                <div class="stat-value">{{ statistics.mainIndustry }}</div>
                <div class="stat-rate">占比：{{ statistics.mainIndustryRate }}%</div>
              </div>
            </div>
          </el-card>
        </el-col>
        
        <!-- 卡片4：总需求面积 -->
        <el-col :span="6">
          <el-card class="stat-card area-card" shadow="hover">
            <div class="stat-content">
              <div class="stat-icon">
                <i class="el-icon-menu"></i>
              </div>
              <div class="stat-info">
                <div class="stat-label">总需求面积</div>
                <div class="stat-value">{{ statistics.totalArea }} ㎡</div>
                <div class="stat-rate">平均：{{ statistics.averageArea }} ㎡/家</div>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <!-- 搜索区域：适配招商表查询条件 -->
    <el-card class="search-card" shadow="never">
      <el-form :model="queryParams" :inline="true" class="search-form">
        <el-form-item label="招商状态：">
          <el-select 
            v-model="queryParams.status" 
            placeholder="请选择状态"
            clearable
            style="width: 140px"
          >
            <el-option label="全部" value=""></el-option>
            <el-option label="已签约" value="已签约"></el-option>
            <el-option label="待签约" value="待签约"></el-option>
            <el-option label="沟通中" value="沟通中"></el-option>
            <el-option label="已放弃" value="已放弃"></el-option>
            <el-option label="暂停" value="暂停"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="行业类别：">
          <el-select 
            v-model="queryParams.industryType" 
            placeholder="请选择行业"
            clearable
            style="width: 140px"
          >
            <el-option label="全部" value=""></el-option>
            <el-option label="人工智能" value="人工智能"></el-option>
            <el-option label="餐饮美食" value="餐饮美食"></el-option>
            <el-option label="娱乐休闲" value="娱乐休闲"></el-option>
            <el-option label="快递服务" value="快递服务"></el-option>
            <el-option label="美容美发" value="美容美发"></el-option>
            <el-option label="医疗卫生" value="医疗卫生"></el-option>
            <el-option label="生活配套" value="生活配套"></el-option>
            <el-option label="超市" value="超市"></el-option>
            <el-option label="其他" value="其他"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="商户名称：">
          <el-input
            v-model="queryParams.merchantName"
            placeholder="请输入商户名称"
            clearable
            style="width: 180px"
          />
        </el-form-item>
        
        <el-form-item label="商户联系人：">
          <el-input
            v-model="queryParams.contactPerson"
            placeholder="请输入联系人"
            clearable
            style="width: 110px"
          />
        </el-form-item>

        <el-form-item label="租金政策：">
          <el-select 
            v-model="queryParams.rentPolicy" 
            placeholder="请选择租金政策"
            clearable
            style="width: 120px"
          >
            <el-option label="全部" value=""></el-option>
            <el-option label="实缴租金" value="实缴租金"></el-option>
            <el-option label="租金优惠" value="租金优惠"></el-option>
            <el-option label="合作联营" value="合作联营"></el-option>
            <el-option label="其他" value="其他"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">
            搜索
          </el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">
            重置
          </el-button>
          <el-button 
            type="success" 
            icon="el-icon-plus" 
            @click="handleAdd"
            class="btn-add"
          >
            新增招商登记
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 数据表格：完全适配招商表字段 -->
    <el-card class="table-card" shadow="never">
      <div class="table-header">
        <div class="table-title">
          <i class="el-icon-store-building"></i>
          邻里中心招商信息管理
        </div>
        <div class="table-actions">
          <el-input
            v-model="quickSearch"
            placeholder="快速搜索（商户/联系人/电话）..."
            prefix-icon="el-icon-search"
            style="width: 280px; margin-right: 10px;"
            size="small"
            clearable
            @input="handleQuickSearch"
          />
        </div>
      </div>
      
      <el-table
        ref="checkinTable"
        v-loading="loading"
        :data="tableData"
        border
        stripe
        style="width: 100%"
        :height="tableHeight"
        >
        <!-- 序号列 -->
        <el-table-column 
          label="序号" 
          width="70"
          align="center"
        >
          <template slot-scope="scope">
            <span class="serial-number">
              {{ (pageIndex - 1) * pageSize + scope.$index + 1 }}
            </span>
          </template>
        </el-table-column>
        
        <!-- 登记日期：招商表核心字段 -->
        <el-table-column 
          prop="registerDate" 
          label="登记日期" 
          width="100"
          align="center"
        />

        <!-- 招商状态：字典值标签化渲染 -->
        <el-table-column 
          prop="status" 
          label="招商状态" 
          width="100"
          align="center"
        >
          <template slot-scope="{ row }">
            <el-tag 
              :type="getStatusTagType(row.status)"
              size="small"
            >
              {{ row.status || '-' }}
            </el-tag>
          </template>
        </el-table-column>
        
        <!-- 商户名称：招商表核心字段 -->
        <el-table-column 
          prop="merchantName" 
          label="商户名称" 
          min-width="200"
          show-overflow-tooltip
        />

        <!-- 行业类别：字典值标签化渲染 -->
        <el-table-column 
          prop="industryType" 
          label="行业类别" 
          width="100"
          align="center"
        >
          <template slot-scope="{ row }">
            <el-tag 
              :type="getIndustryTagType(row.industryType)"
              size="small"
              effect="plain"
            >
              {{ row.industryType || '-' }}
            </el-tag>
          </template>
        </el-table-column>

        <!-- 需求面积：带单位展示 -->
        <el-table-column 
          prop="demandArea" 
          label="需求面积(㎡)" 
          width="110"
          align="center"
        >
          <template slot-scope="{ row }">
            {{ row.demandArea || 0 }}
          </template>
        </el-table-column>

        <!-- 所选位置 -->
        <el-table-column 
          prop="selectPosition" 
          label="所选位置" 
          min-width="150"
          align="center"
          show-overflow-tooltip
        />

        <!-- 租金政策：字典值标签化渲染 -->
        <el-table-column 
          prop="rentPolicy" 
          label="租金政策" 
          width="100"
          align="center"
        >
          <template slot-scope="{ row }">
            <el-tag 
              :type="getRentTagType(row.rentPolicy)"
              size="small"
              effect="plain"
            >
              {{ row.rentPolicy || '-' }}
            </el-tag>
          </template>
        </el-table-column>
        
        <!-- 商户联系人 -->
        <el-table-column 
          prop="contactPerson" 
          label="商户联系人" 
          width="100"
          align="center"
        />
        
        <!-- 联系方式 -->
        <el-table-column 
          prop="contactWay" 
          label="联系方式" 
          width="130"
          align="center"
        />

        <!-- 招商负责人 -->
        <el-table-column 
          prop="principal" 
          label="招商负责人" 
          width="100"
          align="center"
        />
        
        <!-- 更新时间 -->
        <el-table-column 
          prop="updateTime" 
          label="更新时间" 
          width="160"
          align="center"
        >
          <template slot-scope="{ row }">
            <span>{{ formatDate(row.updateTime) }}</span>
          </template>
        </el-table-column>

        <el-table-column 
          prop="progress" 
          label="进展情况" 
          width="500"
          align="center"
        />
        <el-table-column 
          prop="remark" 
          label="备注" 
          width="500"
          align="center"
        />
        
        
        <!-- 操作列：保留原有功能，调整宽度适配 -->
        <el-table-column 
          label="操作" 
          width="300" 
          align="center"
          fixed="right"
        >
          <template slot-scope="{ row }">
            <div class="action-buttons">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-view"
                @click="handleView(row)"
              >
                查看
              </el-button>
              
              <el-button
                type="warning"
                size="mini"
                icon="el-icon-edit"
                @click="handleEdit(row)"
              >
                编辑
              </el-button>
              
              <el-button
                type="danger"
                size="mini"
                icon="el-icon-delete"
                @click="handleDelete(row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页：保留原有逻辑 -->
      <div class="footer-area">
        <el-pagination
          v-if="total > 0"
          class="pagination-container"
          :current-page.sync="pageIndex"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>

    <!-- 新增/编辑对话框：保留原有组件，仅适配字段 -->
    <StoreInformationDialog
      :visible="dialogVisible"
      :form-data="currentFormData"
      :is-edit="isEditMode"
      @close="handleDialogClose"
      @save="handleSave"
    />
  </div>
</template>

<script>
import storeinformationApi from '../api/storeinformation'
import StoreInformationDialog from '../components/StoreInformationDialog.vue'

export default {
  name: "StoreInformation",
  components: {
    StoreInformationDialog
  },
  
  data() {
    return {
      loading: false,
      originalData: [],
      tableData: [],
      filteredData: [],
      total: 0,
      quickSearch: '',
      pageIndex: 1,
      pageSize: 10,
      // 查询参数：完全替换为招商表字段
      queryParams: {
        status: '',        // 招商状态
        industryType: '',  // 行业类别
        merchantName: '',  // 商户名称
        contactPerson: '', // 商户联系人
        rentPolicy: ''     // 租金政策
      },
      dialogVisible: false,
      isEditMode: false,
      currentFormData: {},
      tableHeight: 500,
      searchTimer: null,
      // 新增：统计数据
      statistics: {
        totalCount: 0,          // 总招商登记数
        signedCount: 0,         // 已签约商户数
        signRate: 0,            // 签约率
        mainIndustry: '暂无',   // 主要行业
        mainIndustryRate: 0,    // 主要行业占比
        totalArea: 0,           // 总需求面积
        averageArea: 0          // 平均每家需求面积
      }
    }
  },
  
  created() {
    this.getProfile();
    // 自适应表格高度（调整高度，给统计卡片留出空间）
    this.tableHeight = window.innerHeight - 400;
    window.addEventListener('resize', () => {
      this.tableHeight = window.innerHeight - 400;
    });
  },

  destroyed() {
    window.removeEventListener('resize', () => {});
  },
  
  methods: {
    /**
     * 获取招商信息列表（接口不变，仅返回数据字段适配）
     */
    getProfile() {
      this.loading = true;
      storeinformationApi.getAllStoreInformation(this.queryParams) // 传参给接口，支持后台筛选
        .then((response) => {
          if (response && response.data && response.data.flag === true) {
            this.originalData = response.data.data || [];
            this.filteredData = response.data.data || [];
            this.total = this.originalData.length;
            this.applyFilter();
            // 新增：计算统计数据
            this.calculateStatistics();
            console.log('已加载 ' + this.originalData.length + ' 条招商登记数据');
          } else {
            this.$message.error('获取招商信息列表失败');
            this.resetData();
            // 重置统计数据
            this.resetStatistics();
          }
        }).catch((error) => {
          console.error('获取招商信息列表失败:', error);
          this.$message.error('加载失败，请检查网络连接');
          this.resetData();
          // 重置统计数据
          this.resetStatistics();
        }).finally(() => {
          this.loading = false;
        });
    },

    /**
     * 重置数据（抽离公共方法）
     */
    resetData() {
      this.originalData = [];
      this.filteredData = [];
      this.total = 0;
      this.tableData = [];
    },

    /**
     * 重置统计数据
     */
    resetStatistics() {
      this.statistics = {
        totalCount: 0,
        signedCount: 0,
        signRate: 0,
        mainIndustry: '暂无',
        mainIndustryRate: 0,
        totalArea: 0,
        averageArea: 0
      };
    },
    
    /**
     * 应用分页
     */
    applyPagination() {
      const start = (this.pageIndex - 1) * this.pageSize;
      const end = start + this.pageSize;
      this.tableData = this.filteredData.slice(start, end);
    },
    
    /**
    * 应用筛选：适配招商表字段筛选逻辑（修复ES6+可选链语法，兼容Vue2）
    */
    applyFilter() {
      let filtered = [...this.originalData];
      
      // 1. 招商状态筛选
      if (this.queryParams.status) {
        filtered = filtered.filter(item => item.status === this.queryParams.status);
      }
      // 2. 行业类别筛选
      if (this.queryParams.industryType) {
        filtered = filtered.filter(item => item.industryType === this.queryParams.industryType);
      }
      // 3. 商户名称模糊筛选（替换?.为常规判空）
      if (this.queryParams.merchantName && this.queryParams.merchantName.trim()) {
        const filterVal = this.queryParams.merchantName.trim();
        filtered = filtered.filter(item => item.merchantName && item.merchantName.includes(filterVal));
      }
      // 4. 商户联系人模糊筛选（替换?.为常规判空）
      if (this.queryParams.contactPerson && this.queryParams.contactPerson.trim()) {
        const filterVal = this.queryParams.contactPerson.trim();
        filtered = filtered.filter(item => item.contactPerson && item.contactPerson.includes(filterVal));
      }
      // 5. 租金政策筛选
      if (this.queryParams.rentPolicy) {
        filtered = filtered.filter(item => item.rentPolicy === this.queryParams.rentPolicy);
      }
      // 6. 快速搜索：商户名称/联系人/联系方式（替换?.为常规判空）
      if (this.quickSearch && this.quickSearch.trim()) {
        const searchVal = this.quickSearch.trim().toLowerCase();
        filtered = filtered.filter(item => 
          (item.merchantName && item.merchantName.toLowerCase().includes(searchVal)) ||
          (item.contactPerson && item.contactPerson.toLowerCase().includes(searchVal)) ||
          (item.contactWay && item.contactWay.toLowerCase().includes(searchVal))
        );
      }
      
      this.filteredData = filtered;
      this.total = filtered.length;
      this.pageIndex = 1;
      this.applyPagination();
      
      // 新增：重新计算统计数据
      this.calculateStatistics();
    },

    /**
     * 新增：计算统计数据
     */
    calculateStatistics() {
      const data = this.filteredData;
      const totalCount = data.length;
      
      // 1. 已签约数量和签约率
      const signedCount = data.filter(item => item.status === '已签约').length;
      const signRate = totalCount > 0 ? ((signedCount / totalCount) * 100).toFixed(1) : 0;
      
      // 2. 统计行业分布，找出占比最高的行业
      const industryMap = {};
      data.forEach(item => {
        const industry = item.industryType || '其他';
        industryMap[industry] = (industryMap[industry] || 0) + 1;
      });
      
      let mainIndustry = '暂无';
      let mainIndustryRate = 0;
      if (totalCount > 0 && Object.keys(industryMap).length > 0) {
        // 找出数量最多的行业
        let maxCount = 0;
        for (const [industry, count] of Object.entries(industryMap)) {
          if (count > maxCount) {
            maxCount = count;
            mainIndustry = industry;
          }
        }
        mainIndustryRate = ((maxCount / totalCount) * 100).toFixed(1);
      }
      
      // 3. 计算总需求面积和平均值（适配邻里中心的核心指标）
      let totalArea = 0;
      data.forEach(item => {
        totalArea += Number(item.demandArea) || 0;
      });
      totalArea = totalArea.toFixed(1);
      const averageArea = totalCount > 0 ? (totalArea / totalCount).toFixed(1) : 0;
      
      // 更新统计数据
      this.statistics = {
        totalCount,
        signedCount,
        signRate,
        mainIndustry,
        mainIndustryRate,
        totalArea,
        averageArea
      };
    },
    
    /**
     * 处理搜索
     */
    handleSearch() {
      this.applyFilter();
    },
    
    /**
     * 处理快速搜索（防抖）
     */
    handleQuickSearch() {
      if (this.searchTimer) clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.applyFilter();
      }, 300);
    },
    
    /**
     * 处理重置：重置招商表查询参数
     */
    handleReset() {
      this.queryParams = {
        status: '',
        industryType: '',
        merchantName: '',
        contactPerson: '',
        rentPolicy: ''
      };
      this.quickSearch = '';
      this.pageIndex = 1;
      this.applyFilter();
    },
    
    /**
     * 处理添加：初始化招商表表单数据
     */
    handleAdd() {
      this.currentFormData = {
        status: '沟通中', // 默认初始状态
        industryType: '',
        demandArea: 0,
        selectPosition: '',
        rentPolicy: '',
        merchantName: '',
        contactPerson: '',
        contactWay: '',
        principal: '',
        progress: '',
        remark: ''
      };
      this.isEditMode = false;
      this.dialogVisible = true;
    },
    
    /**
     * 处理编辑：回显招商表所有字段
     */
    handleEdit(row) {
      this.currentFormData = {
        id: row.id,
        registerDate: row.registerDate,
        status: row.status,
        merchantName: row.merchantName,
        industryType: row.industryType,
        demandArea: row.demandArea,
        selectPosition: row.selectPosition,
        rentPolicy: row.rentPolicy,
        contactPerson: row.contactPerson,
        contactWay: row.contactWay,
        progress: row.progress,
        principal: row.principal,
        remark: row.remark,
        updateTime: row.updateTime
      };
      this.isEditMode = true;
      this.dialogVisible = true;
    },
    
    /**
     * 处理查看：展示招商表完整信息
     */
    handleView(row) {
      this.$alert(
        `<div style="line-height: 2; font-size: 14px;">
          <p><strong>登记日期：</strong>${row.registerDate || '-'}</p>
          <p><strong>招商状态：</strong>${row.status || '-'}</p>
          <p><strong>商户名称：</strong>${row.merchantName || '-'}</p>
          <p><strong>行业类别：</strong>${row.industryType || '-'}</p>
          <p><strong>需求面积：</strong>${row.demandArea || 0} ㎡</p>
          <p><strong>所选位置：</strong>${row.selectPosition || '-'}</p>
          <p><strong>租金政策：</strong>${row.rentPolicy || '-'}</p>
          <p><strong>商户联系人：</strong>${row.contactPerson || '-'}</p>
          <p><strong>联系方式：</strong>${row.contactWay || '-'}</p>
          <p><strong>招商负责人：</strong>${row.principal || '-'}</p>
          <p><strong>进展情况：</strong>${row.progress || '-'}</p>
          <p><strong>更新时间：</strong>${this.formatDate(row.updateTime)}</p>
          <p><strong>备注：</strong>${row.remark || '-'}</p>
        </div>`,
        '招商信息详情',
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '关闭',
          width: '500px'
        }
      );
    },
    
    /**
     * 处理删除：保留原有逻辑
     */
    handleDelete(row) {
      const merchantName = row.merchantName || '该招商登记信息';
      this.$confirm(`确定要删除"${merchantName}"吗？`, '提示', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        return storeinformationApi.deletestoreinformation(row.id);
      }).then((response) => {
        if (response.data && response.data.flag === true) {
          this.$message.success('删除成功');
          this.getProfile();
        } else {
          this.$message.error('删除失败');
        }
      }).catch((error) => {
        if (error && error !== 'cancel') {
          console.error('删除失败:', error);
          this.$message.error('删除失败，请重试');
        }
      });
    },
    
    /**
     * 分页相关方法：保留原有逻辑
     */
    handleSizeChange(size) {
      this.pageSize = size;
      this.pageIndex = 1;
      this.applyPagination();
    },
    handleCurrentChange(page) {
      this.pageIndex = page;
      this.applyPagination();
    },
    
    /**
     * 对话框相关方法：保留原有逻辑
     */
    handleDialogClose() {
      this.dialogVisible = false;
      this.currentFormData = {};
    },
    handleSave(formData) {
      const promise = this.isEditMode 
        ? storeinformationApi.updatestoreinformation(formData) 
        : storeinformationApi.addstoreinformation(formData);
      
      promise.then((response) => {
        if (response && response.data && response.data.flag === true) {
          this.$message.success(this.isEditMode ? '更新成功' : '新增成功');
          this.dialogVisible = false;
          this.currentFormData = {};
          this.getProfile();
        } else {
          const message = (response && response.data && response.data.message) || '保存失败';
          this.$message.error(message);
        }
      }).catch((error) => {
        console.error('保存失败:', error);
        this.$message.error('保存失败，请重试');
      });
    },
    
    /**
     * 格式化日期：兼容空值和字符串日期
     */
    formatDate(dateStr) {
      if (!dateStr) return '-';
      try {
        const date = new Date(dateStr);
        return date.toLocaleString('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        });
      } catch (e) {
        return dateStr;
      }
    },
    
    /**
     * 招商状态标签颜色（核心：区分不同状态，突出已签约/已放弃）
     */
    getStatusTagType(status) {
      const map = {
        '已签约': 'success', // 绿色
        '待签约': 'warning', // 黄色
        '沟通中': 'primary', // 蓝色
        '已放弃': 'danger',  // 红色
        '暂停': 'info'       // 灰色
      };
      return map[status] || 'info';
    },

    /**
     * 行业类别标签颜色
     */
    getIndustryTagType(industry) {
      const map = {
        '人工智能': 'primary',
        '餐饮美食': 'success',
        '娱乐休闲': 'warning',
        '快递服务': 'info',
        '美容美发': 'purple',
        '医疗卫生': 'danger',
        '生活配套': 'orange',
        '超市': 'green',
        '其他': 'gray'
      };
      return map[industry] || 'gray';
    },

    /**
     * 租金政策标签颜色
     */
    getRentTagType(policy) {
      const map = {
        '实缴租金': 'primary',
        '租金优惠': 'success',
        '合作联营': 'warning',
        '其他': 'info'
      };
      return map[policy] || 'info';
    }
  }
}
</script>

<style scoped>
.store-checkin-container {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: calc(100vh - 84px); /* 适配全屏高度 */
}

/* 新增：统计卡片样式 */
.statistics-card-container {
  margin-bottom: 20px;
}

.stat-card {
  border-radius: 8px;
  border: none;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.1);
}

.stat-content {
  display: flex;
  align-items: center;
  padding: 10px 0;
}

.stat-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  flex-shrink: 0;
}

.stat-icon i {
  font-size: 24px;
  color: #fff;
}

/* 不同卡片的图标背景色 */
.total-card .stat-icon {
  background: linear-gradient(135deg, #409eff, #66b1ff);
}

.signed-card .stat-icon {
  background: linear-gradient(135deg, #67c23a, #85ce61);
}

.industry-card .stat-icon {
  background: linear-gradient(135deg, #e6a23c, #ebb563);
}

.area-card .stat-icon {
  background: linear-gradient(135deg, #f56c6c, #f78989);
}

.stat-info {
  flex: 1;
}

.stat-label {
  font-size: 14px;
  color: #909399;
  margin-bottom: 5px;
}

.stat-value {
  font-size: 24px;
  font-weight: 600;
  color: #303133;
  line-height: 1;
  margin-bottom: 5px;
}

.stat-rate {
  font-size: 12px;
  color: #666;
}

.search-card {
  margin-bottom: 20px;
  border-radius: 8px;
  border: none;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.search-form {
  margin-bottom: -10px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.btn-add {
  background-color: #67c23a;
  border-color: #67c23a;
  color: white;
}
.btn-add:hover {
  background-color: #5eba2f !important;
  border-color: #5eba2f !important;
}

.table-card {
  border-radius: 8px;
  overflow: hidden;
  border: none;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding: 0 8px;
}

.table-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  display: flex;
  align-items: center;
}

.table-title i {
  margin-right: 8px;
  color: #409EFF;
  font-size: 20px;
}

.footer-area {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #ebeef5;
}

.pagination-container {
  text-align: right;
}

.action-buttons {
  display: flex;
  justify-content: center;
  gap: 8px;
}

.serial-number {
  color: #909399;
  font-weight: 500;
}

/* 表格样式优化：适配多列，提升可读性 */
.el-table {
  font-size: 14px;
}

.el-table th {
  background-color: #f8f9fa !important;
  font-weight: 600;
  color: #333;
}

.el-table td, .el-table th {
  padding: 10px 0;
  border-bottom: 1px solid #ebeef5;
}

/* 固定列样式优化 */
.el-table__fixed-right {
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.02);
}

/* 响应式适配：小屏幕隐藏部分非核心列（可根据需求调整） */
@media screen and (max-width: 1600px) {
  .el-table-column--fixed-right {
    width: 180px !important;
  }
  .action-buttons {
    gap: 4px;
  }
  .el-button--mini {
    padding: 4px 6px;
  }
}

/* 响应式适配统计卡片 */
@media screen and (max-width: 1200px) {
  .stat-value {
    font-size: 20px;
  }
}

@media screen and (max-width: 768px) {
  .statistics-card-container .el-row {
    flex-direction: column;
  }
  .statistics-card-container .el-col {
    width: 100% !important;
    margin-bottom: 15px;
  }
}
</style>